module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-bc57214a.png";